import React from 'react'
import ReactDOM from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import App from './App'
import './index.css'
import { applyColorPreset } from './utils/colorPresets.js'

// Apply your preferred color preset
applyColorPreset('ocean')  // Change to 'forest', 'sunset', or 'default'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>,
)
